// extracted by mini-css-extract-plugin
module.exports = {"land-status":"c6e8ba5398--land-status--OJKkJ"};